var __jsx = React.createElement;
import React from "react";
import { CopilotKit } from "@copilotkit/react-core";
import { get } from "lodash";
import { useAuth } from "@qure/qure-auth";
import Sidebar from "./Sidebar";

/**
 * Peer of CopilotWrapper: wraps the app when Aira's chat is served by
 * orqestrator instead of the CopilotKit/gpt-4o runtime.
 *
 * Chosen at the call site in pages/_app.js so CopilotWrapper stays untouched,
 * and nothing here has to bend around the shape of the chat it replaces.
 *
 * It still mounts <CopilotKit>, which looks odd for a component whose whole
 * point is not using CopilotKit's chat. Two reasons:
 *
 *   1. Necessity. Roughly 42 useCopilotAction call sites live in ordinary
 *      screens (Menubar.tsx, Patients/index.tsx), and useCopilotContext throws
 *      outright without the provider, so leaving it out white-screens the app
 *      on navigation rather than merely disabling the chat.
 *   2. Intent. Those actions are the registry orqestrator's tool calls should
 *      eventually dispatch into, so keeping them registered is the direction of
 *      travel, not a stopgap.
 *
 * No CopilotSidebar is rendered, so `runtimeUrl` is never exercised: the gpt-4o
 * backend is not called while this component is mounted.
 */

var OrqChat = function OrqChat(_ref) {
  var children = _ref.children;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  return /*#__PURE__*/React.createElement(CopilotKit, {
    runtimeUrl: "/api/copilotkit",
    headers: {
      "x-ai-assistant-enabled": userInfo ? String(isEnabled) : ""
    },
    showDevConsole: false
  }, children, /*#__PURE__*/React.createElement(Sidebar, null));
};
export default OrqChat;